import React from 'react';
import { cn, getVisibility, getTitleSizeStyle } from '../../utils/helpers';

const Text = ({ block }) => {
  if (block.align === 'Left') {
    block.align_class = ' text-left';
  } else {
    block.align_class = ' text-center';
  }

  const additionalTitleProperties = {};
  if (typeof block.title_id === 'string' && block.title_id.length > 0) {
    additionalTitleProperties.id = block.title_id;
  }

  const showClass = getVisibility(block.block_visibility);
  const titleSize = getTitleSizeStyle(block.title_size);
  // This is the only way to get the mobile title size to work
  // when title_size.mobile value is not being passed to the component.
  const titleMobile = block.title_mobile
    ? block.title_mobile
    : titleSize.mobile
      ? block.title
      : null;

  return (
    <section
      className={cn(
        `block ${showClass} ${block._template} ${block.css_class_name ? block.css_class_name : ''} ${block.align_class} ${block.side_cta && block.side_cta.url ? 'has-side-cta' : ''}`
      )}
    >
      <div className='container'>
        <div
          className='title-wr'
          {...additionalTitleProperties}
        >
          {titleMobile ? (
            <>
              <h2
                className={`is-desktop`}
                dangerouslySetInnerHTML={{ __html: block.title }}
                style={titleSize.desktop}
              ></h2>
              <h2
                className={`is-mobile`}
                dangerouslySetInnerHTML={{ __html: titleMobile }}
                style={titleSize.mobile}
              ></h2>
            </>
          ) : (
            block.title && (
              <h2
                dangerouslySetInnerHTML={{ __html: block.title }}
                {...titleSize.desktop}
              ></h2>
            )
          )}

          {block.side_cta && (
            <a
              className='side-cta'
              href={block.side_cta.url}
            >
              {block.side_cta.title}
            </a>
          )}
        </div>
        {block.text && (
          <div
            className='text-formatted text-normal'
            dangerouslySetInnerHTML={{ __html: block.text }}
          ></div>
        )}
        {block.small_text && (
          <div
            className='text-formatted text-small'
            dangerouslySetInnerHTML={{ __html: block.small_text }}
          ></div>
        )}
      </div>
    </section>
  );
};

export default Text;
